import React, { createContext, useState } from 'react';
import {
  getToken as getAuthToken,
  setToken,
  removeToken,
  replaceToken,
} from '@utils';

export const AuthContext = createContext({
  isAuthenticated: false,
  setAuth: () => {},
  removeAuth: () => {},
  getToken: () => {},
  refreshToken: () => {},
});

export const AuthContextProvider = ({ children }) => {
  const setAuth = access_token => {
    setToken(access_token);
    setAuthState(prevState => {
      return {
        ...prevState,
        isAuthenticated: true,
      };
    });
  };

  const removeAuth = () => {
    removeToken();
    setAuthState(prevState => {
      return {
        ...prevState,
        isAuthenticated: false,
      };
    });
  };

  const checkAuth = () => {
    const token = getAuthToken();
    return token.length > 0;
  };

  const getToken = () => {
    return getAuthToken();
  };

  const refreshToken = token => {
    replaceToken(token);
  };

  const initialAuthState = {
    isAuthenticated: checkAuth(),
    setAuth,
    removeAuth,
    getToken,
    refreshToken,
  };

  const [authState, setAuthState] = useState(initialAuthState);

  return (
    <AuthContext.Provider value={authState}>{children}</AuthContext.Provider>
  );
};

export const AuthContextConsumer = AuthContext.Consumer;
